

































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class DistrictSearch extends Vue {
  private search: string = this.$store.state.districtState.searchText
  @Prop() private total!: number

  private doDistrictSearch () {
    /* キーワード検索 */
    this.$store.commit('districtState/setSearchText', this.search)
    this.$store.commit('districtState/setSortName', 'created_at')
    this.$store.commit('districtState/setSortAsc', false)

    this.$emit('get-list')
  }

  /* リセット */
  private doClear () {
    // stateリセット
    this.$store.commit('districtState/setSearchText', '')
    this.$store.commit('districtState/setSortName', 'created_at')
    this.$store.commit('districtState/setSortAsc', false)
    this.search = ''

    this.$emit('get-list')
  }

  private doShowAreaAlert () {
    this.$emit('show-alert')
  }
}
